import React from 'react';
import { cn } from '../index';

const variants = {
  default: 'bg-[var(--muted)] text-[var(--muted-fg)] border-[var(--border)]',
  success: 'bg-[color-mix(in_srgb,var(--success)_12%,transparent)] text-[var(--success)] border-[color-mix(in_srgb,var(--success)_28%,transparent)]',
  warning: 'bg-[color-mix(in_srgb,var(--warning)_12%,transparent)] text-[var(--warning)] border-[color-mix(in_srgb,var(--warning)_28%,transparent)]',
  danger: 'bg-[color-mix(in_srgb,var(--destructive)_12%,transparent)] text-[var(--destructive)] border-[color-mix(in_srgb,var(--destructive)_28%,transparent)]',
  info: 'bg-[color-mix(in_srgb,var(--info)_12%,transparent)] text-[var(--info)] border-[color-mix(in_srgb,var(--info)_28%,transparent)]',
  outline: 'bg-transparent text-[var(--fg-muted)] border-[var(--border)]',
  primary: 'bg-[color-mix(in_srgb,var(--primary)_12%,transparent)] text-[var(--primary)] border-[color-mix(in_srgb,var(--primary)_28%,transparent)]',
} as const;

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: keyof typeof variants;
}

export const Badge: React.FC<BadgeProps> = ({ className, variant = 'default', ...props }) => (
  <span
    className={cn(
      'inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium',
      variants[variant],
      className,
    )}
    {...props}
  />
);
